import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, DownloadIcon, MailIcon, EditIcon, PrinterIcon, CheckCircleIcon, XCircleIcon, MoreHorizontalIcon, ArchiveIcon, TrashIcon, UserIcon, PhoneIcon, MapPinIcon, CreditCardIcon, TagIcon, FileTextIcon, AlertTriangleIcon, ClockIcon, PackageIcon, TruckIcon, CalendarIcon, CheckIcon } from 'lucide-react';
import { Order, OrderStatus } from './Orders';
export function OrderDetail() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  // Mock data based on the ID or default
  const order: Order = {
    id: id || '220629-1e753',
    status: 'new',
    paymentStatus: 'paid',
    customer: {
      name: 'randy',
      email: 'randy@randy.com',
      address: 'randy',
      mobileNumber: '6596605522',
      additionalPhone: '1234',
      address2: '1234'
    },
    items: [{
      name: 'Kittens',
      quantity: 2,
      price: 111.0
    }],
    total: 222.0,
    date: '29/06/2022',
    time: '14:28',
    transaction: '62bc1b4be3c2250009f1e753',
    transactionStatus: 'confirmed',
    notes: 'Please deliver between 9 AM and 5 PM.'
  };
  const getStatusBadge = (status: OrderStatus) => {
    const styles = {
      new: 'bg-blue-50 text-blue-700 border-blue-200',
      'in-progress': 'bg-amber-50 text-amber-700 border-amber-200',
      open: 'bg-purple-50 text-purple-700 border-purple-200',
      completed: 'bg-green-50 text-green-700 border-green-200',
      cancelled: 'bg-red-50 text-red-700 border-red-200'
    };
    const labels = {
      new: 'New',
      'in-progress': 'In Progress',
      open: 'Open',
      completed: 'Completed',
      cancelled: 'Cancelled'
    };
    return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium border ${styles[status]}`} data-id="element-9381">
        {labels[status]}
      </span>;
  };
  const getPaymentMethod = (transaction?: string) => {
    if (!transaction) return 'Unknown payment method';
    if (transaction.startsWith('62')) return 'Credit Card';
    return 'Bank Transfer';
  };
  const getShippingStatus = (status: OrderStatus) => {
    switch (status) {
      case 'new':
        return 'Awaiting processing';
      case 'in-progress':
        return 'Processing';
      case 'open':
        return 'Ready for pickup';
      case 'completed':
        return 'Delivered';
      case 'cancelled':
        return 'Cancelled';
      default:
        return 'Unknown';
    }
  };
  const formatDate = (dateString: string) => {
    const parts = dateString.split('/');
    if (parts.length !== 3) return dateString;
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const day = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1;
    const year = parseInt(parts[2]);
    return `${day} ${months[month]} ${year}`;
  };
  return <div className="max-w-[1400px] mx-auto space-y-6" data-id="element-9382">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-9383">
        <div className="flex items-center gap-4" data-id="element-9384">
          <button onClick={() => navigate('/orders')} className="p-2 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-9385">
            <ArrowLeftIcon size={18} data-id="element-9386" />
          </button>
          <div data-id="element-9387">
            <div className="flex items-center gap-3" data-id="element-9388">
              <h1 className="text-xl font-semibold text-gray-900" data-id="element-9389">
                Order #{order.id}
              </h1>
              {getStatusBadge(order.status)}
            </div>
            <p className="text-sm text-gray-500 mt-0.5" data-id="element-9390">
              {order.customer.name}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2" data-id="element-9391">
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors" data-id="element-9392">
            <MailIcon size={16} data-id="element-9393" />
            Send
          </button>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors" data-id="element-9394">
            <DownloadIcon size={16} data-id="element-9395" />
            Download
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-[#F7941D] hover:bg-[#D97B06] text-white text-sm font-medium rounded-lg transition-colors shadow-sm" data-id="element-9396">
            <CheckCircleIcon size={16} data-id="element-9397" />
            Mark Fulfilled
          </button>
          <div className="relative" data-id="element-9398">
            <button onClick={() => setShowMoreMenu(!showMoreMenu)} className="p-2 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-9399">
              <MoreHorizontalIcon size={18} data-id="element-9400" />
            </button>
            {showMoreMenu && <>
                <div className="fixed inset-0 z-10" onClick={() => setShowMoreMenu(false)} data-id="element-9401" />
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20" data-id="element-9402">
                  <button onClick={() => setShowMoreMenu(false)} className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-9403">
                    <PrinterIcon size={16} className="mr-3 text-gray-400" data-id="element-9404" />
                    Print Order
                  </button>
                  <button onClick={() => setShowMoreMenu(false)} className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-9405">
                    <EditIcon size={16} className="mr-3 text-gray-400" data-id="element-9406" />
                    Edit Order
                  </button>
                  <div className="border-t border-gray-100 my-1" data-id="element-9407" />
                  <button onClick={() => setShowMoreMenu(false)} className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-9408">
                    <TrashIcon size={16} className="mr-3" data-id="element-9409" />
                    Cancel Order
                  </button>
                </div>
              </>}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-9410">
        {/* Main Content */}
        <div className="lg:col-span-2 space-y-6" data-id="element-9411">
          {/* Order Items */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9412">
            <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center" data-id="element-9413">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9414">
                <PackageIcon size={18} className="text-gray-500" data-id="element-9415" />
                Order Items
              </h2>
            </div>
            <div className="p-6" data-id="element-9416">
              <div className="space-y-4" data-id="element-9417">
                {order.items.map((item, index) => <div key={index} className="flex justify-between border-b border-gray-100 pb-4 last:border-0 last:pb-0" data-id="element-9418">
                    <div data-id="element-9419">
                      <div className="font-medium text-gray-900" data-id="element-9420">
                        {item.name}
                      </div>
                      <div className="text-sm text-gray-500 mt-1" data-id="element-9421">
                        Quantity: {item.quantity} × ${item.price.toFixed(2)}
                      </div>
                    </div>
                    <div className="font-medium text-gray-900" data-id="element-9422">
                      ${(item.price * item.quantity).toFixed(2)}
                    </div>
                  </div>)}
              </div>

              <div className="mt-6 border-t border-gray-100 pt-4 space-y-3" data-id="element-9423">
                <div className="flex justify-between text-sm" data-id="element-9424">
                  <span className="text-gray-500" data-id="element-9425">Subtotal</span>
                  <span className="text-gray-900 font-medium" data-id="element-9426">
                    ${order.total.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-9427">
                  <span className="text-gray-500" data-id="element-9428">Shipping</span>
                  <span className="text-gray-900 font-medium" data-id="element-9429">$0.00</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-9430">
                  <span className="text-gray-500" data-id="element-9431">Tax</span>
                  <span className="text-gray-900 font-medium" data-id="element-9432">$0.00</span>
                </div>
                <div className="flex justify-between text-base font-semibold pt-3 border-t border-gray-100" data-id="element-9433">
                  <span className="text-gray-900" data-id="element-9434">Total</span>
                  <span className="text-[#F7941D]" data-id="element-9435">
                    ${order.total.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Order Timeline */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9436">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9437">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9438">
                <ClockIcon size={18} className="text-gray-500" data-id="element-9439" />
                Order Timeline
              </h2>
            </div>
            <div className="p-6" data-id="element-9440">
              <div className="space-y-6" data-id="element-9441">
                <div className="flex items-start" data-id="element-9442">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-9443">
                    <CheckIcon size={14} className="text-green-600" data-id="element-9444" />
                  </div>
                  <div className="ml-4" data-id="element-9445">
                    <p className="text-sm font-medium text-gray-900" data-id="element-9446">
                      Order placed
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-9447">
                      {formatDate(order.date)} at {order.time}
                    </p>
                  </div>
                </div>

                {order.status === 'in-progress' || order.status === 'completed' ? <div className="flex items-start" data-id="element-9448">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-amber-100 flex items-center justify-center mt-0.5" data-id="element-9449">
                      <CheckIcon size={14} className="text-amber-600" data-id="element-9450" />
                    </div>
                    <div className="ml-4" data-id="element-9451">
                      <p className="text-sm font-medium text-gray-900" data-id="element-9452">
                        Processing started
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-9453">
                        Order is being processed
                      </p>
                    </div>
                  </div> : <div className="flex items-start" data-id="element-9454">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mt-0.5" data-id="element-9455">
                      <span className="text-xs font-medium text-gray-500" data-id="element-9456">
                        2
                      </span>
                    </div>
                    <div className="ml-4" data-id="element-9457">
                      <p className="text-sm font-medium text-gray-500" data-id="element-9458">
                        Processing
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-9459">
                        Waiting to be processed
                      </p>
                    </div>
                  </div>}

                {order.status === 'completed' ? <div className="flex items-start" data-id="element-9460">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-9461">
                      <CheckIcon size={14} className="text-green-600" data-id="element-9462" />
                    </div>
                    <div className="ml-4" data-id="element-9463">
                      <p className="text-sm font-medium text-gray-900" data-id="element-9464">
                        Completed
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-9465">
                        Order has been fulfilled
                      </p>
                    </div>
                  </div> : <div className="flex items-start" data-id="element-9466">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mt-0.5" data-id="element-9467">
                      <span className="text-xs font-medium text-gray-500" data-id="element-9468">
                        3
                      </span>
                    </div>
                    <div className="ml-4" data-id="element-9469">
                      <p className="text-sm font-medium text-gray-500" data-id="element-9470">
                        Completed
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-9471">
                        Waiting to be completed
                      </p>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-6" data-id="element-9472">
          {/* Customer Information */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9473">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9474">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9475">
                <UserIcon size={18} className="text-gray-500" data-id="element-9476" />
                Customer Information
              </h2>
            </div>
            <div className="p-6 space-y-4" data-id="element-9477">
              <div className="flex items-center gap-3 mb-2" data-id="element-9478">
                <div className="w-10 h-10 bg-[#F7941D]/10 rounded-full flex items-center justify-center text-[#F7941D] font-semibold" data-id="element-9479">
                  {order.customer.name.charAt(0).toUpperCase()}
                </div>
                <div data-id="element-9480">
                  <div className="font-medium text-gray-900" data-id="element-9481">
                    {order.customer.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-9482">
                    Customer #{order.id.split('-')[0]}
                  </div>
                </div>
              </div>

              <div className="space-y-3 pt-2 border-t border-gray-100" data-id="element-9483">
                <div className="flex items-start gap-3" data-id="element-9484">
                  <MailIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9485" />
                  <div data-id="element-9486">
                    <div className="text-sm text-gray-900" data-id="element-9487">
                      {order.customer.email}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9488">Email</div>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-9489">
                  <PhoneIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9490" />
                  <div data-id="element-9491">
                    <div className="text-sm text-gray-900" data-id="element-9492">
                      {order.customer.mobileNumber}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9493">Mobile</div>
                  </div>
                </div>
                {order.customer.additionalPhone && <div className="flex items-start gap-3" data-id="element-9494">
                    <PhoneIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9495" />
                    <div data-id="element-9496">
                      <div className="text-sm text-gray-900" data-id="element-9497">
                        {order.customer.additionalPhone}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-9498">
                        Additional Phone
                      </div>
                    </div>
                  </div>}
                <div className="flex items-start gap-3" data-id="element-9499">
                  <MapPinIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9500" />
                  <div data-id="element-9501">
                    <div className="text-sm text-gray-900" data-id="element-9502">
                      {order.customer.address}
                    </div>
                    {order.customer.address2 && <div className="text-sm text-gray-900 mt-0.5" data-id="element-9503">
                        {order.customer.address2}
                      </div>}
                    <div className="text-xs text-gray-500 mt-0.5" data-id="element-9504">
                      Shipping Address
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Information */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9505">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9506">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9507">
                <CreditCardIcon size={18} className="text-gray-500" data-id="element-9508" />
                Payment Information
              </h2>
            </div>
            <div className="p-6 space-y-4" data-id="element-9509">
              <div className="flex items-start gap-3" data-id="element-9510">
                <CreditCardIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9511" />
                <div data-id="element-9512">
                  <div className="text-sm text-gray-900" data-id="element-9513">
                    {getPaymentMethod(order.transaction)}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-9514">Payment Method</div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-9515">
                <TagIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9516" />
                <div data-id="element-9517">
                  <div className="text-sm text-gray-900 capitalize" data-id="element-9518">
                    {order.paymentStatus}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-9519">Payment Status</div>
                </div>
              </div>
              {order.transaction && <div className="flex items-start gap-3" data-id="element-9520">
                  <FileTextIcon size={16} className="text-gray-400 mt-0.5" data-id="element-9521" />
                  <div data-id="element-9522">
                    <div className="text-sm text-gray-900 break-all" data-id="element-9523">
                      {order.transaction}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9524">Transaction ID</div>
                  </div>
                </div>}
              {order.transactionStatus && <div className="flex items-start gap-3" data-id="element-9525">
                  {order.transactionStatus === 'confirmed' ? <CheckCircleIcon size={16} className="text-green-500 mt-0.5" data-id="element-9526" /> : order.transactionStatus === 'failed' ? <AlertTriangleIcon size={16} className="text-red-500 mt-0.5" data-id="element-9527" /> : <ClockIcon size={16} className="text-amber-500 mt-0.5" data-id="element-9528" />}
                  <div data-id="element-9529">
                    <div className="text-sm text-gray-900 capitalize" data-id="element-9530">
                      {order.transactionStatus}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9531">
                      Transaction Status
                    </div>
                  </div>
                </div>}
            </div>
          </div>

          {/* Shipping Status */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-9532">
            <div className="px-6 py-4 border-b border-gray-100" data-id="element-9533">
              <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2" data-id="element-9534">
                <TruckIcon size={18} className="text-gray-500" data-id="element-9535" />
                Shipping Status
              </h2>
            </div>
            <div className="p-6" data-id="element-9536">
              <div className="text-sm font-medium text-gray-900 mb-4" data-id="element-9537">
                {getShippingStatus(order.status)}
              </div>
              {order.notes && <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-9538">
                  <div className="text-xs font-medium text-gray-700 mb-1" data-id="element-9539">
                    Customer Notes:
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-9540">{order.notes}</p>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}